import { css, styled } from 'styled-components';

export const ProfileOpportunitiesWrapper = styled.div<{
  visitorCanEdit: boolean;
}>`
  max-width: 1096px;
  margin: 24px auto;
  ${({ visitorCanEdit }) => css`
    margin-top: ${visitorCanEdit ? '0px' : undefined};
    margin-bottom: ${visitorCanEdit ? '112px' : '24px'};
  `}
`;
